import { useEffect } from "react";
import api from "@/lib/api";

// AVA Fleet SSO landing: hands the mothership token to our backend for verification,
// which mints THIS app's own session, then drops the user into the app.
export default function AvaSso() {
  useEffect(() => {
    const token = new URLSearchParams(window.location.search).get("ava_sso_token");
    if (!token) { window.location.replace("/login?sso=missing"); return; }
    api.post("/api/ava-sso/verify", { token })
      .then(() => window.location.replace("/app"))
      .catch(() => window.location.replace("/login?sso=denied"));
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#050505]" data-testid="ava-sso-page">
      <p className="mono-label" style={{ color: "#0047FF" }}>Signing you in…</p>
    </div>
  );
}
